/**
 * Tab Accessibility - Make inactive tabs focusable
 * Removes tabindex="-1" from inactive tabs to allow keyboard navigation
 *
 * @since 1.0.0
 */

/**
 * Initialize tab keyboard accessibility
 * Allows users to tab through all tabs instead of just the active one
 * Uses MutationObserver to catch tabindex additions from Bootstrap
 */
export function initTabKeyboardNav() {
	document.querySelectorAll('.wp-block-pacecore-blocks-tabs').forEach((tabsBlock) => {
		const navTabs = tabsBlock.querySelector('.nav-tabs');

		if (!navTabs) return;

		// Make tab panels focusable so keyboard users can reach the active
		// panel content, which is otherwise skipped when it has no focusable
		// children. Hidden (inactive) panels stay out of the tab order.
		tabsBlock.querySelectorAll('.tab-pane[role="tabpanel"]').forEach((panel) => {
			panel.setAttribute('tabindex', '0');
		});

		// Remove any existing tabindex attributes
		navTabs.querySelectorAll('.nav-link[tabindex]').forEach((tab) => {
			tab.removeAttribute('tabindex');
		});

		// Watch for tabindex additions on any nav-link in the nav-tabs
		const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (mutation.target.classList.contains('nav-link') && mutation.attributeName === 'tabindex') {
					mutation.target.removeAttribute('tabindex');
				}
			});
		});

		// Single observer on parent with subtree to catch all nav-links
		observer.observe(navTabs, {
			attributes: true,
			attributeFilter: ['tabindex'],
			subtree: true
		});
	});
}
